import React from "react"
import { getPath } from "../components/utils"
import Img from "gatsby-image"
import { Link } from "gatsby"
import styles from "../styles/postList.module.css"
import { GoDiffModified } from 'react-icons/go'
import { AiFillYoutube } from 'react-icons/ai'
import {isMobile, isAndroid, isIOS} from 'react-device-detect';

const PostPreview = ({document}) => {
    let postMetaList = []
    postMetaList.push(document.recipe_category? document.recipe_category.name : null)
    postMetaList.push(document.recipe_cuisine? document.recipe_cuisine.name: null)
    const postMeta = postMetaList.filter((x) => x).join(' · ')
    return(
        <div className={styles.postPreview}>
            <Img fluid={{...document.featureImage.childImageSharp.fluid, aspectRatio: 1}}/>
            {/* <Img fixed={document.featureImage.childImageSharp.fixed}/>  */}
            <div className={styles.postHeaderContainer}>
                <h2 className={isMobile? styles.postHeaderMobile: styles.postHeader}>{document.title}</h2>
                <div className={styles.headerIcons}>
                    {document.youtubeURL? <AiFillYoutube className={styles.icon} color='red' size={isMobile? '1.4em': '1.7em'}/>: ''}
                    <GoDiffModified className={styles.icon2} color={document.nonVeg? "red": "green"}  size={isMobile? '1em': '1.3em'}/>
                </div>
            </div>
            <div className={styles.postMetaData}>
                <span> {postMeta} </span>
            </div>
        </div>
    )
}

const postList = ({data, extension, count}) => {
    extension = extension? extension : ''
    let displayPosts = data
    if(count && (count < data.length)){
        displayPosts = data.slice(0, count)
    }
    return (
        <div className={styles.postListContainer}>
            {displayPosts.map((document) => {
                const postData = document.node? document.node: document
                return <Link key={postData.id} className={isMobile? styles.postContainerMobile: styles.postContainer}
                    to={
                        getPath(
                            postData.websiteURL, 
                            postData.created_at,
                            postData.title,
                            extension
                        )
                    }
                >
                    <PostPreview document={postData} />
                </Link>
            })}
        </div>
    )
}

export default postList